import { render, staticRenderFns } from "./DistrictsLayout.vue?vue&type=template&id=62ab32a6&scoped=true&lang=pug&"
import script from "./DistrictsLayout.vue?vue&type=script&lang=ts&"
export * from "./DistrictsLayout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ab32a6",
  null
  
)

export default component.exports